/* Gedeelde constanten voor het Talent Search-scherm. */
export const COUNTRIES = [
    { v: "", l: "Alle" },
    { v: "BE", l: "België" },
    { v: "NL", l: "Nederland" },
    { v: "BE/NL", l: "BE + NL" },
    { v: "DACH", l: "DACH" },
    { v: "EU", l: "Europa" },
    { v: "UK", l: "UK" },
    { v: "US", l: "US" },
];

export const SIZES = [
    { v: "", l: "Alle sizes" },
    { v: "1-10", l: "1–10" },
    { v: "11-50", l: "11–50" },
    { v: "51-200", l: "51–200" },
    { v: "201-500", l: "201–500" },
    { v: "501-1000", l: "501–1K" },
    { v: "1000+", l: "1K+" },
];

const SOURCE_LABELS = { apollo: "Apollo", linkedin_serper: "LinkedIn X-ray", linkedin_apify: "LinkedIn (Apify)", perplexity: "Perplexity Web" };
export const sourceLabelOf = (id) => SOURCE_LABELS[id] || id;
